import {set, filter} from "lodash"

const initialState = {
  deal: {},
  load: null,
  touched: false
}

const NewDealReducer = (state = initialState, action) => {
  const {deal, load, key, value, isToggledBoostedSavings, product, currency} = action
  switch (action.type) {
    case "DEAL_SET_VALUE":
      return setValue(state, deal, key, value)
    case "DEAL_SET_OBJECT":
      return setDeal(state, deal)
    case "DEAL_SET_LOAD":
      return setLoad(state, load)
    case "DEAL_ADD_PRODUCT":
      return addProduct(state, deal, product, currency)
    case "DEAL_REMOVE_PRODUCT":
      return removeProduct(state, deal, product)
    case "TOGGLE_BOOSTED_SAVINGS":
      return toggleBoostedSavings(state, deal, isToggledBoostedSavings)
    default:
      return state
  }
}

export default NewDealReducer

function toggleBoostedSavings(state, deal, toggled) {
  const boostedSavings = toggled
    ? {
        oldSavings: {
          ...deal.savings.userSavings
        }
      }
    : null

  return {
    ...state,
    touched: true,
    deal: {
      ...deal,
      savings: {
        ...deal.savings,
        boostedSavings
      }
    }
  }
}

function addProduct(state, deal, product, currency) {
  const products = [...deal.productConfig.products]
  products.push({
    uuid: product.uuid,
    data: product.data,
    salePrice: {discount: null, value: null, currency},
    name: product.name,
    type: product.type,
    supplier: product.supplier
  })
  return setValue(state, deal, "productConfig.products", products)
}

function removeProduct(state, deal, product) {
  const products = filter(deal.productConfig.products, (compare) => compare.uuid !== product.uuid)

  return setValue(state, deal, "productConfig.products", products)
}

function setValue(state, deal, key, value) {
  set(deal, key, value)
  return {
    ...state,
    touched: true,
    deal: {
      ...deal
    }
  }
}

function setDeal(state, deal) {
  return {
    ...state,
    touched: false,
    deal: {
      ...deal
    }
  }
}

function setLoad(state, load) {
  return {
    ...state,
    load
  }
}
